import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "mx-2"
};
const _hoisted_2 = {
  class: "mx-2"
};
const _hoisted_3 = {
  class: "mx-2"
};
import { nextTick } from "vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import { app } from "@/di";
import LineupHandler from "@/modules/team/services/LineupHandler";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerSelection',
  props: {
    players: null,
    formation: null,
    nextMatch: null
  },
  emits: ['updated'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const lineup = ref();
    const position = ref();
    const actionSheet = ref(null);
    const show = (l, p) => {
      lineup.value = l;
      position.value = p;
      nextTick(() => actionSheet.value.show());
    };
    const hide = () => actionSheet.value.hide();
    const currentPlayer = computed(() => props.players.find(p => p.lineup === lineup.value));
    const playerForPosition = computed(() => props.players.filter(p => p.lineup !== lineup.value && p.position === position.value));
    const otherPlayersPosition = computed(() => props.players.filter(p => !p.lineup && p.position !== position.value));
    const unselect = async player => {
      await app.get(LineupHandler).remove(player);
      emit('updated');
    };
    const select = async player => {
      await app.get(LineupHandler).set(props.players, player, lineup.value);
      emit('updated');
      hide();
    };
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(SimpleActionSheet, {
        ref_key: "actionSheet",
        ref: actionSheet
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(position.value ? position.value.toUpperCase() : null), 1)]),
        default: _withCtx(() => [_createElementVNode("div", null, [_unref(currentPlayer) ? (_openBlock(), _createBlock(_component_NDivider, {
          key: 0
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('current')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _unref(currentPlayer) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(PlayerList, {
          players: [_unref(currentPlayer)],
          "show-talent": ""
        }, {
          afterAction: _withCtx(({
            player
          }) => [_createVNode(_component_NButton, {
            secondary: "",
            type: "error",
            size: "tiny",
            onClick: $event => unselect(player)
          }, {
            default: _withCtx(() => [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.CloseOutline
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["players"])])) : _createCommentVNode("", true), _unref(playerForPosition).length > 0 ? (_openBlock(), _createBlock(_component_NDivider, {
          key: 2
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('same_position')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(PlayerList, {
          players: _ctx.collect(_unref(playerForPosition)).sortByDesc('skill'),
          "show-talent": ""
        }, {
          afterAction: _withCtx(({
            player
          }) => [_createVNode(_component_NButton, {
            secondary: "",
            type: "success",
            size: "tiny",
            onClick: $event => select(player)
          }, {
            default: _withCtx(() => [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.CheckRound
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["players"])]), _unref(otherPlayersPosition).length > 0 ? (_openBlock(), _createBlock(_component_NDivider, {
          key: 3
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('not_linedup')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(PlayerList, {
          players: _ctx.collect(_unref(otherPlayersPosition)).sortByDesc('skill'),
          "show-talent": ""
        }, {
          afterAction: _withCtx(({
            player
          }) => [_createVNode(_component_NButton, {
            secondary: "",
            type: "success",
            size: "tiny",
            onClick: $event => select(player)
          }, {
            default: _withCtx(() => [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.CheckRound
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["players"])])])]),
        _: 1
      }, 512);
    };
  }
});